import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
	search,
	searchMyTickets,
	get,
	getEmailInfo,
	getChangeLogs,
	add,
	update,
	advancedSearch,
} from '../../modules/ticket';

const apiBase = 'ticket';
const listName = `${apiBase}s`;
const idField = `${apiBase}Id`;
const idsField = `${idField}s`;

const mapStateToProps = (state, ownProps) => {
	const newState = {};

	/** @namespace state.lists.stationInvoiceIds **/
	/** @namespace state.maps.stationInvoice **/
	/** @namespace state.maps.user **/
	let openTickets = undefined;
	let closedTickets = undefined;
	let billingTickets = undefined;
	if (state.ticket && state.ticket.byStatus) {
		const { open, closed, billing } = state.ticket.byStatus;
		if (open) {
			openTickets = _.map(open, (id) => state.maps.ticket[id]);
		}
		if (closed) {
			closedTickets = _.map(closed, (id) => state.maps.ticket[id]);
		}

		if (billing) {
			billingTickets = _.map(billing, (id) => state.maps.ticket[id]);
		}

		newState.openTickets = openTickets;
		newState.closedTickets = closedTickets;
		newState.billingTickets = billingTickets;
	}

	const id = ownProps[idField] ? ownProps[idField] : _.get(ownProps, ['match', 'params', idField]);

	newState[apiBase] = _.get(state.maps, [apiBase, id]);

	newState[listName] = [];
	if (state.lists[idsField]) {
		newState[listName] = _.map(state.lists[idsField], (id) => state.maps[apiBase][id]);
	}

	if (state.ticket && state.ticket.myTicketIds) {
		newState.myTickets = _.map(state.ticket.myTicketIds, (id) => state.maps[apiBase][id]);
	}

	//- Get any ticket logs for this ticket
	/** @namespace state.lists.ticketChangeLogIds **/
	/** @namespace state.lists.ticketChangeLog **/
	if (state.lists.ticketChangeLogIds && state.lists.ticketChangeLogIds[id]) {
		newState.ticketChangeLogs = _.map(
			state.lists.ticketChangeLogIds[id],
			(id) => state.maps.ticketChangeLog[id]
		);
	}

	newState.ticketCategoryMap = state.maps.ticketCategory;
	newState.ticketSchemaMap = state.maps.ticketSchema;
	newState.userMap = state.maps.user;
	newState.resourceMap = state.maps.resource;
	return newState;
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			getTicket: get,
			getTicketEmailInfo: getEmailInfo,
			getTicketChangeLogs: getChangeLogs,
			searchTickets: search,
			searchMyTickets: searchMyTickets,
			advancedTicketSearch: advancedSearch,
			addTicket: add,
			updateTicket: update,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
